export const CSRF = 'CSRF';
export const USERNAME = 'R_USERNAME';
export const LOCALE = 'R_LOCALE';
